<template>
  <q-card class="rounded-xl border border-neutral-100/5 shadow-sm">
    <div class="p-24 pb-0 md2:pt-16 md2:px-16">
      <div class="flex items-center justify-between">
        <TextIcon
          icon="svguse:#icon_bar_line_chart"
          text="Cup Evolution"
          icon-class="text-primary-pure"
          div-class="!gap-12 !font-normal "
        />

        <q-spinner-tail
          v-if="evolutionSeriesLoading"
          color="primary"
          size="1.5rem"
        />
      </div>

      <VueApexCharts
        ref="chartCupEvolutionRef"
        height="320"
        :options="chartOptions"
        :series="evolutionSeries"
      />

      <q-list>
        <q-item
          v-for="(_item, _index) in evolutionSeries"
          :key="_index"
          class="flex items-center py-0 px-16 md2:px-8 h-40 border-b last:border-b-0 border-neutral-100/10"
          clickable
          @mouseenter="highlightSeries(_index)"
          @mouseleave="clearHighlight"
        >
          <div class="flex flex-1 px-8 gap-8 items-center">
            <span
              class="block w-4 h-20 rounded-lg"
              :style="{ backgroundColor: colors[_index] }"
            />

            <strong class="text-headline-3 text-black line-clamp-1">
              {{ _item.name }}
            </strong>
          </div>

          <div class="w-160">
            <strong class="text-headline-3 text-black line-clamp-1">
              {{ _item.data.at(-1).replace('.', ',') }}
            </strong>
          </div>

          <OButton
            :class="{
              'opacity-0 !pointer-events-none': _item.fixed,
            }"
            size="sm"
            tertiary
            icon="close"
            icon-size="1.5rem"
            class="size-40 !border-none !bg-transparent"
            @click="removeComparisonEvolution(_index)"
          />
        </q-item>
      </q-list>
    </div>

    <div
      class="p-24 !pt-16 border-t border-neutral-100/10 space-y-16 md2:p-16"
    >
      <h2 class="text-headline-2 text-black">
        Adicione um novo indicador para comparação:
      </h2>

      <div class="flex justify-between gap-8 sm:flex-col">
        <MenuCompare type="graphic" />

        <OButton
          v-if="evolutionSeries.find((s) => s.fixed === false)"
          size="lg"
          tertiary
          icon="close"
          icon-size="1.5rem"
          class="sm:w-full"
          label="Remover tudo"
          @click="removeComparisonEvolution()"
        />
      </div>
    </div>
  </q-card>
</template>

<script setup>
import {
  evolutionSeries,
  evolutionSeriesLoading,
} from 'store/copa.stores'
import { ref } from 'vue'
import MenuCompare from './MenuCompare.vue'
import OButton from 'components/Button/OButton.vue'
import TextIcon from 'components/Text/TextIcon.vue'
import VueApexCharts from 'vue3-apexcharts'
import useCopaReports from 'composables/useCopaReports'

const { removeComparisonEvolution } = useCopaReports()

const chartCupEvolutionRef = ref(null)

// Métodos para highlight do gráfico
const highlightSeries = (seriesIndex) => {
  if (
    chartCupEvolutionRef.value &&
    chartCupEvolutionRef.value.chart
  ) {
    // Cria array de cores com opacidade reduzida para séries não destacadas
    const highlightColors = colors.map((color, index) => {
      return index === seriesIndex ? color : color + '40' // 40 = 25% opacidade em hex
    })

    // Atualiza as cores do gráfico
    chartCupEvolutionRef.value.chart.updateOptions({
      colors: highlightColors,
    })
  }
}

const clearHighlight = () => {
  if (
    chartCupEvolutionRef.value &&
    chartCupEvolutionRef.value.chart
  ) {
    // Restaura as cores originais
    chartCupEvolutionRef.value.chart.updateOptions({
      colors: colors,
    })
  }
}

const colors = [
  '#EF4108',
  '#73A9D6',
  '#A873D6',
  '#E7A413',
  '#73D691',
  '#DC3CC6',
  '#6FE9E9',
]

const chartOptions = {
  chart: {
    height: 320,
    type: 'line',
    zoom: { enabled: false },
    toolbar: { show: false },
  },
  stroke: { width: 2 },
  markers: {
    size: 4,
    strokeWidth: 0,
  },
  colors: colors,
  legend: { show: false },
  yaxis: {
    labels: {
      formatter: (val) => val.toFixed(1).replace('.', ','),
    },
  },
  xaxis: {
    categories: [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ],
    axisBorder: { color: '#000' },
  },
  grid: {
    borderColor: '#E9E9EA',
    xaxis: {
      lines: { show: true },
    },
  },
}
</script>
